"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OceanAccounts_1 = require("./OceanAccounts");
var OceanAgreements_1 = require("./OceanAgreements");
var OceanAssets_1 = require("./OceanAssets");
var OceanAuth_1 = require("./OceanAuth");
var OceanSecretStore_1 = require("./OceanSecretStore");
var OceanTokens_1 = require("./OceanTokens");
var OceanVersions_1 = require("./OceanVersions");
var OceanUtils_1 = require("./utils/OceanUtils");
var Aquarius_1 = require("../aquarius/Aquarius");
var Brizo_1 = require("../brizo/Brizo");
var Keeper_1 = __importDefault(require("../keeper/Keeper"));
var Instantiable_abstract_1 = require("../Instantiable.abstract");
var Ocean = (function (_super) {
    __extends(Ocean, _super);
    function Ocean() {
        return _super.call(this) || this;
    }
    Ocean.getInstance = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var instance, instanceConfig, _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        instance = new Ocean();
                        instanceConfig = __assign(__assign({}, Instantiable_abstract_1.generateIntantiableConfigFromConfig(config)), { ocean: instance });
                        instance.setInstanceConfig(instanceConfig);
                        _a = instance;
                        return [4, Keeper_1.default.getInstance(instanceConfig)];
                    case 1:
                        _a.keeper = _k.sent();
                        instance.brizo = new Brizo_1.Brizo(instanceConfig);
                        instance.aquarius = new Aquarius_1.Aquarius(instanceConfig);
                        _b = instance;
                        return [4, OceanAccounts_1.OceanAccounts.getInstance(instanceConfig)];
                    case 2:
                        _b.accounts = _k.sent();
                        _c = instance;
                        return [4, OceanAuth_1.OceanAuth.getInstance(instanceConfig)];
                    case 3:
                        _c.auth = _k.sent();
                        _d = instance;
                        return [4, OceanAssets_1.OceanAssets.getInstance(instanceConfig)];
                    case 4:
                        _d.assets = _k.sent();
                        _e = instance;
                        return [4, OceanAgreements_1.OceanAgreements.getInstance(instanceConfig)];
                    case 5:
                        _e.agreements = _k.sent();
                        _f = instance;
                        return [4, OceanSecretStore_1.OceanSecretStore.getInstance(instanceConfig)];
                    case 6:
                        _f.secretStore = _k.sent();
                        _g = instance;
                        return [4, OceanTokens_1.OceanTokens.getInstance(instanceConfig)];
                    case 7:
                        _g.tokens = _k.sent();
                        _h = instance;
                        return [4, OceanVersions_1.OceanVersions.getInstance(instanceConfig)];
                    case 8:
                        _h.versions = _k.sent();
                        _j = instance;
                        return [4, OceanUtils_1.OceanUtils.getInstance(instanceConfig)];
                    case 9:
                        _j.utils = _k.sent();
                        return [2, instance];
                }
            });
        });
    };
    return Ocean;
}(Instantiable_abstract_1.Instantiable));
exports.Ocean = Ocean;
//# sourceMappingURL=Ocean.js.map